import ButtonWithIcon from "@/components/common/button-with-icon";
import copyLinkIcon from "@/assets/icons/copy-link-icon.svg";
import copyLinkActiveIcon from "@/assets/icons/copy-link-active-icon.svg";
import useHover from "@/hooks/use-hover";
import { useCopyContext } from "@/hooks/providers/copy-provider";

type CopyToClipboardButtonProps = {
  textToCopy: string;
  size?: number;
};

const CopyToClipboardButton = ({
  textToCopy,
  size = 40,
}: CopyToClipboardButtonProps) => {
  const { isTextCopied, copyText } = useCopyContext();
  const { isHovering, onMouseLeave, onMouseEnter } = useHover();

  return (
    <div onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
      <ButtonWithIcon
        isEnabled={true}
        tooltip={"Copy"}
        size={size}
        iconPath={
          isHovering || isTextCopied(textToCopy)
            ? copyLinkActiveIcon
            : copyLinkIcon
        }
        handleClick={() => copyText(textToCopy)}
      />
    </div>
  );
};

export default CopyToClipboardButton;
